import { graphql } from 'gatsby';
import { StyledContainer, StyledContent, StyledSection } from './ColumnBlock.styles';
import ColumnBlockColumnItem from './components/ColumnBlockColumnItem/ColumnBlockColumnItem';
import { applyPaddingCSS } from '@/utils/generatePadding';
import ColumnBlockHeader from './components/ColumnBlockHeader/ColumnBlockHeader';
import { type BlockHTMLId } from '@/utils/renderBlock';

const ColumnBlock = ({
  columnBlockElements: elements,
  system,
  id,
}: Queries.COLUMN_BLOCKFragment & BlockHTMLId) => {
  const { columns, content_layout } = elements;

  return (
    <StyledSection data-codename={system.codename} css={applyPaddingCSS(elements)} id={id}>
      <StyledContainer layout={content_layout.value}>
        <ColumnBlockHeader {...elements} />
        <StyledContent>
          {columns.value.map((col) => (
            <ColumnBlockColumnItem key={col.system.id} {...col} layout={content_layout.value} />
          ))}
        </StyledContent>
      </StyledContainer>
    </StyledSection>
  );
};

export const fragment = graphql`
  fragment COLUMN_BLOCK on kontent_item_column_block {
    system {
      codename
      type
      id
    }
    columnBlockElements: elements {
      ...COMPONENT_A_B_TEST
      ...COMPONENT_PERSONALIZATION
      ...PADDING
      ...COLUMN_BLOCK_HEADER
      columns {
        value {
          ...COLUMN_BLOCK_COLUMN_ITEM
        }
      }
      content_layout {
        value
      }
    }
  }
`;

export default ColumnBlock;
